import React, { useEffect, useState } from "react";
import { Lightbulb } from "@bloomberg/media-ui-icons";
import { Popover } from "@bloomberg/media-ui-overlay";

export const getSearchTipDismissalValueFromLocalStorage = (key: string) =>
    typeof window !== "undefined" ? localStorage.getItem(key) : null;
const setSearchTipDismissalToLocalStorage = (key: string) => {
    localStorage.setItem(key, `${Date.now()}`);
};

interface SearchTipPopoverProps {
    localStorageDismissalKey: string;
    anchorEl: Element | null;
    eyebrow: string;
    text: string;
}

export const SearchTipPopover = ({
    localStorageDismissalKey,
    anchorEl,
    eyebrow,
    text,
}: SearchTipPopoverProps) => {
    const [_, setSearchButtonClicked] = useState(false);

    useEffect(() => {
        if (!anchorEl) return () => {};

        function navSearchButtonTipClickHandler() {
            if (
                anchorEl &&
                !getSearchTipDismissalValueFromLocalStorage(
                    localStorageDismissalKey
                )
            ) {
                setSearchTipDismissalToLocalStorage(localStorageDismissalKey);
                // Trigger a rerender, where next render
                // getSearchTipDismissalValueFromLocalStorage
                // will return what was set above
                setSearchButtonClicked(true);
            }

            anchorEl?.removeEventListener(
                "click",
                navSearchButtonTipClickHandler
            );
        }

        // Dismiss tip if we click on the search button
        anchorEl.addEventListener("click", navSearchButtonTipClickHandler);

        return () => {
            anchorEl.removeEventListener(
                "click",
                navSearchButtonTipClickHandler
            );
        };
    }, [anchorEl]);

    return anchorEl &&
        !getSearchTipDismissalValueFromLocalStorage(
            localStorageDismissalKey
        ) ? (
        <Popover
            Icon={<Lightbulb />}
            eyebrow={eyebrow}
            anchorElement={anchorEl}
            allowedPlacements={["bottom-end"]}
            onDismiss={() =>
                setSearchTipDismissalToLocalStorage(localStorageDismissalKey)
            }
            text={text}
            floatingStrategy="fixed"
        />
    ) : null;
};
